import type {KeyTextField} from '@prismicio/client'
import type {FourGridSliceCards} from 'prismicio-types'
import {LinkWrapper} from 'src/common/LinkWrapper'
import {Card} from './Card'

type ExtendedSectionProps = {
  title?: KeyTextField
  cards: NonNullable<FourGridSliceCards['primary']['extended_section']>
  pageUid: string
  componentIndex: number
}

export const ExtendedSection = ({title, cards, pageUid, componentIndex}: ExtendedSectionProps) => {
  if (!cards || cards.length === 0) {
    return null
  }

  return (
    <div className="flex w-full flex-col gap-8">
      {title && <h3 className="text-tg-h3 text-moss-black">{title}</h3>}

      <div className="grid grid-cols-1 gap-6 min-[500px]:grid-cols-2 lg:grid-cols-4">
        {cards.map((card, index) => (
          <LinkWrapper
            key={`extended-card-link-${index}`}
            link={card.link}
            mktgId="four-grid-extended-card"
            location={`component-${componentIndex}-extended-card-${index}`}
            pageName={pageUid}
            dataType={`extended-card-${index}`}
            className="group/extended-card"
          >
            <Card title={card.title || ''} subtitle={card.subtitle || ''} icon={card.icon} />
          </LinkWrapper>
        ))}
      </div>
    </div>
  )
}
